export default __webpack_public_path__ + "static/media/010-mouse.af8ece58.svg";